import { useEffect, useRef, useState, useCallback } from 'react';

const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

const getWsUrl = (path) => {
  if (API_BASE) {
    return API_BASE.startsWith("https://")
      ? API_BASE.replace("https://", "wss://") + path
      : API_BASE.replace("http://", "ws://")  + path;
  }
  // Relative: use current host
  const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${window.location.host}${path}`;
};

export const useChatWebSocket = (conversationId, currentUser) => {
  const [messages,     setMessages]     = useState([]);
  const [isConnected,  setIsConnected]  = useState(false);
  const [wsStatus,     setWsStatus]     = useState("closed");
  const [peerPresence, setPeerPresence] = useState({ status: "offline", lastSeen: null });
  const socketRef = useRef(null);

  useEffect(() => {
    if (!conversationId || !currentUser) return;
    const token = localStorage.getItem("user_token");
    if (!token) return;

    setWsStatus("connecting");
    const url    = getWsUrl(`/ws/chat/tradelink/${conversationId}/?token=${token}`);
    const socket = new WebSocket(url);
    socketRef.current = socket;

    socket.onopen = () => {
      setIsConnected(true);
      setWsStatus("open");
      socket.send(JSON.stringify({ type: "mark_read" }));
    };

    socket.onmessage = (event) => {
      const data          = JSON.parse(event.data);
      const currentUserId = currentUser.id || currentUser.pk || currentUser.user_id;

      if (data.type === "read_receipt") {
        if (data.reader_id !== currentUserId)
          setMessages(prev => prev.map(m => ({ ...m, status: "read" })));
      } else if (data.type === "presence") {
        if (data.user_id !== currentUserId)
          setPeerPresence({ status: data.status, lastSeen: data.last_seen });
      } else if (data.type === "chat_message") {
        setMessages(prev => [...prev, data]);
        if (data.sender !== currentUserId && socket.readyState === WebSocket.OPEN)
          socket.send(JSON.stringify({ type: "mark_read" }));
      }
    };

    socket.onerror  = () => setWsStatus("error");
    socket.onclose  = () => { setIsConnected(false); setWsStatus("closed"); };

    return () => socket.close();
  }, [conversationId, currentUser]);

  const sendMessage = useCallback((text) => {
    if (socketRef.current?.readyState === WebSocket.OPEN) {
      socketRef.current.send(JSON.stringify({ message: text }));
      return true;
    }
    return false;
  }, []);

  return { messages, setMessages, isConnected, wsStatus, sendMessage, peerPresence };
};
